import React, { useState, useEffect } from "react";
import styles from "../commanstyles.module.css";
import { FaMinusSquare, FaPlusSquare } from "react-icons/fa";
import { IoMdLock } from "react-icons/io";

const LLPCertifier = ({ apiData = [], isSubScribe }) => {
  const [expandedCertifier, setExpandedCertifier] = useState(null);
  const [isTableOpen, setIsTableOpen] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedYear, setSelectedYear] = useState("");
  const rowsPerPage = 10;

  const toggleRow = (id) => {
    setExpandedCertifier((prev) => (prev === id ? null : id));
  };

  const toggleTable = () => setIsTableOpen((prev) => !prev);

  const getAvailableYears = () => {
    const years = Array.from(
      new Set(apiData.map((item) => item.financial_year))
    );
    return years.sort((a, b) => b - a);
  };

  useEffect(() => {
    const years = getAvailableYears();
    if (years.length > 0) {
      setSelectedYear(years[0]);
    }
  }, [apiData]);

  const filteredData = selectedYear
    ? apiData.filter((item) => item.financial_year === parseInt(selectedYear))
    : apiData;

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = filteredData.slice(indexOfFirstRow, indexOfLastRow);

  return (
    <div className={styles.table_subcontainer}>
      {!isSubScribe ? (
        <button className={styles.Subscription_msg}>
          <IoMdLock /> Subscription required to view data
        </button>
      ) : (
        <>
          <div className={styles.highlet_header_content1}>
            <p className={styles.minuse_icon} onClick={toggleTable}>
              {isTableOpen ? (
                <FaMinusSquare size={22} />
              ) : (
                <FaPlusSquare size={22} />
              )}
            </p>
            <h3 className={styles.highlet_text}>CERTIFIER(S)</h3>

            {getAvailableYears().length > 0 && (
              <div className={styles.yearSelectContainer}>
                <select
                  value={selectedYear}
                  onChange={(e) => {
                    setSelectedYear(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  {getAvailableYears().map((year) => (
                    <option key={year} value={year}>
                      {parseInt(year) - 1} - {year}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>

          {isTableOpen && (
            <>
              <table className={styles.commantable}>
                <thead className={styles.tableHeaderRow}>
                  <tr>
                    <th className={styles.tableHeader}>Year</th>
                    <th className={styles.tableHeader}>Certifier Name(s)</th>
                    <th className={styles.tableHeader}>Designation</th>
                    <th className={styles.tableHeader}>Firm Name(s)</th>
                    <th className={styles.tableHeader}>Address</th>
                  </tr>
                </thead>
                <tbody>
                  {currentData.length > 0 ? (
                    currentData.map((certifier) => (
                      <React.Fragment key={certifier.id}>
                        <tr className={styles.tableRow}>
                          <td className={styles.tableCell}>
                            {certifier.financial_year}
                          </td>
                          <td
                            className={styles.tableCell}
                            onClick={() => toggleRow(certifier.id)}
                          >
                            <div className={styles.tableCell_gstnumber}>
                              {expandedCertifier === certifier.id ? (
                                <FaMinusSquare />
                              ) : (
                                <FaPlusSquare />
                              )}
                              {certifier.certifier_name}
                            </div>
                          </td>
                          <td className={styles.tableCell}>
                            {certifier.designation}
                          </td>
                          <td className={styles.tableCell}>
                            {certifier.firm_name}
                          </td>
                          <td className={styles.tableCell}>
                            {certifier.address}
                          </td>
                        </tr>

                        {expandedCertifier === certifier.id && (
                          <tr>
                            <td colSpan="5">
                              {certifier.certifierDetails?.length > 0 && (
                                <>
                                  <h4>
                                    Representative list of corporate audited by{" "}
                                    {certifier.certifier_name}
                                  </h4>
                                  <table className={styles.commantable}>
                                    <thead className={styles.tableHeaderRow}>
                                      <tr>
                                        <th className={styles.tableHeader}>
                                          Corporate Name
                                        </th>
                                        <th className={styles.tableHeader}>
                                          PUC (cr.)
                                        </th>
                                        <th className={styles.tableHeader}>
                                          SOC (cr.)
                                        </th>
                                        <th className={styles.tableHeader}>
                                          DOI
                                        </th>
                                        <th className={styles.tableHeader}>
                                          Address
                                        </th>
                                        <th className={styles.tableHeader}>
                                          Status
                                        </th>
                                        <th className={styles.tableHeader}>
                                          Auditor Firm
                                        </th>
                                        <th className={styles.tableHeader}>
                                          Last Date of Audit
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {certifier.certifierDetails.map(
                                        (detail, i) => (
                                          <tr key={i}>
                                            <td className={styles.tableCell}>
                                              {detail.corporate_name}
                                            </td>
                                            <td className={styles.tableCell}>
                                              {detail.puc}
                                            </td>
                                            <td className={styles.tableCell}>
                                              {detail.soc}
                                            </td>
                                            <td className={styles.tableCell}>
                                              {detail.doi
                                                ? new Date(
                                                    detail.doi
                                                  ).toLocaleDateString("en-GB")
                                                : "-"}
                                            </td>
                                            <td className={styles.tableCell}>
                                              {detail.address}
                                            </td>
                                            <td className={styles.tableCell}>
                                              {detail.status}
                                            </td>
                                            <td className={styles.tableCell}>
                                              {detail.auditor_firm_name}
                                            </td>
                                            <td className={styles.tableCell}>
                                              {detail.last_date_audit
                                                ? new Date(
                                                    detail.last_date_audit
                                                  ).toLocaleDateString(
                                                    "en-GB",
                                                    {
                                                      day: "numeric",
                                                      month: "short",
                                                      year: "numeric",
                                                    }
                                                  )
                                                : "-"}
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                </>
                              )}
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className={styles.noDocumentsFound}>
                        No Certifier Data Available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              {/* Pagination */}
              {totalPages > 1 && (
                <div className={styles.pagination}>
                  <button
                    onClick={() =>
                      setCurrentPage((prev) => Math.max(prev - 1, 1))
                    }
                    disabled={currentPage === 1}
                  >
                    &lt;
                  </button>
                  {[...Array(totalPages)].map((_, index) => (
                    <button
                      key={index}
                      className={currentPage === index + 1 ? styles.active : ""}
                      onClick={() => setCurrentPage(index + 1)}
                    >
                      {index + 1}
                    </button>
                  ))}
                  <button
                    onClick={() =>
                      setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                    }
                    disabled={currentPage === totalPages}
                  >
                    &gt;
                  </button>
                </div>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default LLPCertifier;
